import styled from 'styled-components';

export const TextInfo = styled.p`
  color: #c94c4c;
  font-size: 26px;
  letter-spacing: 1px;
`;
